import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {alertTypes, useAlerts} from '../ui/alert';
import {parametrosGetThunk, parametrosGetDuck} from './duck';
import {responseSelector} from '../utils/utils';
import {ParametrosListView} from './ParametrosListView';
import {useQueryParams} from '../utils/useQueryParams';

const queryString = require('query-string');

export const ParametrosList = ({history, token}) => {
  const {queryParams, queryParamsloaded} = useQueryParams(history);

  const dispatch = useDispatch();

  const parametrosGet = useSelector(state => state.parametrosGet);

  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalResults, setTotalResults] = useState(0);
  const [lista, setLista] = useState(null);

  const {submitAlert, setTopAlert, topAlert} = useAlerts();

  const _getFiltersFromQueryParams = queryParams => {
    const page = Number(queryParams?.page ?? 1);

    return {
      page,
    };
  };

  const getParametros = filters => {
    if (!filters) {
      throw new Error('No filters received');
    }

    dispatch(
      parametrosGetThunk({
        userToken: token.raw,
        limit: pageSize,
        page: filters.page,
      }),
    );
  };

  useEffect(() => {
    if (!queryParamsloaded) return;

    const filters = _getFiltersFromQueryParams(queryParams);

    setPage(filters.page);

    setFilters(filters);
    getParametros(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, queryParamsloaded]);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(parametrosGet);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(parametrosGetDuck.actions.clear());
    }

    if (data) {
      setTotalResults(data.count);
      setLista(data.items);

      dispatch(parametrosGetDuck.actions.clear());
    }
  }, [parametrosGet]);

  const handlePage = page => {
    const strNewParams = queryString.stringify({
      page,
    });

    history.replace(`${history.location.pathname}?${strNewParams}`);
  };

  return (
    <ParametrosListView
      history={history}
      topAlert={topAlert}
      submitAlert={submitAlert}
      totalResults={totalResults}
      page={page}
      pageSize={pageSize}
      handlePage={handlePage}
      lista={lista}
      parametrosGet={parametrosGet}
    />
  );
};
